import React from "react";

const Footer = () => {
  return (
    <div className="main-footer">
      <h2>
        ‘Flexbox in CSS’ is free to use and it’s developed using React.js, Get
        in touch with developer in{" "}
        <a
          href="https://www.instagram.com/shahirdev/"
          target="_blank"
          rel="noreferrer"
        >
          Instagram
        </a>
        , and{" "}
        <a
          href="https://www.linkedin.com/in/shahir-hossaini/"
          target="_blank"
          rel="noreferrer"
        >
          LinkedIn
        </a>
      </h2>
    </div>
  );
};

export default Footer;
